<template>
  <DashboardCard :border="false" :title="$t('widgets.season.title')">
    <template v-slot:content>
      <div
          style="width: 200px; height: 200px;"
          class="p-2 mx-auto border rounded-circle shadow-circle mt-4"
      >
        <Doughnut :chart-data="chartData" :chart-options="chartOptions" :plugins="[centerTextPlugin]" />
      </div>
    </template>

    <template v-slot:table>
      <MDBTable borderless class="table-dashboard mx-auto p-0">
        <tbody>
        <tr
            v-for="(label, i) in labels"
            :key="i"
            class="border fs-12px"
        >
          <td>
                <span
                    class="legend-circle"
                    :style="{ backgroundColor: colors[i] }"
                ></span>
            {{ label }}
          </td>
          <td>{{ percentages[i] }}</td>
        </tr>
        </tbody>
      </MDBTable>
    </template>
  </DashboardCard>
</template>

<script setup>
import { computed, defineProps } from "vue";
import DashboardCard from "../User/Wholesaler/DashboardCard.vue";
import { MDBTable } from "mdb-vue-ui-kit";
import { Doughnut } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";
import { createCenterTextPlugin } from "../../utils/chartPlugins";
import { useI18n } from "vue-i18n";

ChartJS.register(Title, Tooltip, Legend, ArcElement);

const props = defineProps({
  data: { type: Object, required: true },
});

const { t } = useI18n();

const businessUnits = computed(() => [
  { key: "summer", label: t("trainings.seasons.summer") },
  { key: "winter", label: t("trainings.seasons.winter") },
  { key: "all_season", label: t("trainings.seasons.all") },
]);

const labels = computed(() => businessUnits.value.map((unit) => unit.label));

const percentages = computed(() => [
  props.data.summer_percent,
  props.data.winter_percent,
  props.data.all_season_percent,
])

const colors = ["#FF0230", "#4E9DFF", "#FF9E27"];

const chartData = computed(() => ({
  labels: labels.value,
  datasets: [
    {
      data: [
        props.data.summer,
        props.data.winter,
        props.data.all_season,
      ],
      backgroundColor: colors,
      borderColor: "#fff",
      borderWidth: 2,
      spacing: 3,
    },
  ],
}));

const chartOptions = {
  responsive: true,
  cutout: "70%",
  plugins: {
    legend: { display: false },
    tooltip: {
      enabled: true,
      callbacks: {
        label: function (ctx) {
          const value = ctx.raw;
          const percent = props.data[`${businessUnits.value[ctx.dataIndex].key}_percent`] || 0;
          return ` ${ctx.label}: ${value} (${percent}%)`;
        },
      },
    },
  },
};

const centerTextPlugin = createCenterTextPlugin(
    t("widgets.season.centerTitle"),
    {
      color: "#000",
      weight: "700",
      divisor: 15,
    }
);
</script>

<style scoped lang="scss">
@import "@/styles/_variables.scss";
@import "@/styles/table_dashboard.scss";

.legend-circle {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 8px;
}
</style>
